<form id="tagsForm" [formGroup]="form" autocomplete="off">
  <div class="d-lg-flex align-items-center mb-2">
    <app-client-autocomplete [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    @if (selectedClient) {
      <div class="d-flex">
        <label class="control-label me-2">{{'i18n.domain.reports.filter.fields.company' | translate}}:</label>
        <app-autocomplete #companyAutocomplete
                          [getDataFunction]="searchCompanyDropdownValues.bind(this)"
                          [(value)]="selectedCompanyId"
                          [isFormComponent]="true"
                          placeholder="i18n.domain.reports.filter.fields.company-dropdown-placeholder"
                          id="companyId"
                          class="me-2">
        </app-autocomplete>
      </div>
      <div class="d-flex">
        <label class="control-label me-2">{{'i18n.domain.reports.filter.fields.parker' | translate}}:</label>
        <app-autocomplete [getDataFunction]="searchParkerDropdownValues.bind(this)"
                          [(value)]="selectedParkerId"
                          [isFormComponent]="true"
                          placeholder="i18n.domain.reports.filter.fields.parker-dropdown-placeholder"
                          id="parkerId"
                          class="me-2">
        </app-autocomplete>
      </div>
      <div class="d-flex">
        <label class="control-label me-2">{{'i18n.domain.reports.filter.fields.search' | translate}}:</label>
        <app-search-field #searchField
                          placeholderText="i18n.domain.reports.filter.fields.searchText"
                          (searchTextChanged)="onSearchTextChanged($event)"
                          id="searchText">
        </app-search-field>
        <app-error-messages [control]="form.controls.searchText"></app-error-messages>
      </div>
    }
  </div>
</form>
